import { FC, useState } from 'react';

import styled from 'styled-components';

import {
  SearchBarRangeDatePicker,
  SearchBarSingleDatePicker,
} from '@components/views/flight/listing/SearchBar/DateSelect/DateSelect';
import { FlightTripType } from '@components/views/flight/types';
import { useCustomMobileDesktopBreakpoint } from '@hooks/hooks';
import { DateType, formatMomentDate } from '@utils/dateUtil';
import {
  LANDING_BREAKPOINT,
  LANDING_BREAKPOINT_VALUE,
} from '@utils/theme/breakPoint';
import ResponsiveSingleDateSelect from '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveSingleDateSelect';
import ResponsiveDateRangeSelect from '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveDateRangeSelect';
import { getDateRangePickerPlaceholder } from '@components/views/flight/listing/SearchBar/DateSelect/utils';

const BookerSearchBarDateRangeInputWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.white};
  padding: 0 15px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 0;
    border-top: unset;

    .react-tiny-popover-container {
      width: 570px !important;
      top: -20px !important;
    }
  }
`;

interface Dates {
  startDate?: DateType | null;
  endDate?: DateType | null;
}

const BookerFlightDatePicker: FC<{
  tripType: FlightTripType;
  initialDates?: Dates;
  dateChange: (dates?: Dates) => void;
  error?: boolean;
}> = ({ tripType, dateChange, initialDates, error }) => {
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    initialDates?.startDate || null
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(
    initialDates?.endDate || null
  );

  const onDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
    if (startDate && endDate) dateChange({ startDate, endDate });
  };

  const onDateChange = (date: moment.Moment | null) => {
    setLocalStartDate(date);
    dateChange({ startDate: date });
  };
  const { xl } = useCustomMobileDesktopBreakpoint(LANDING_BREAKPOINT_VALUE);

  return (
    <BookerSearchBarDateRangeInputWrapper>
      {tripType === 'one-way' ? (
        xl ? (
          <SearchBarSingleDatePicker
            date={localStartDate}
            onDateChange={onDateChange}
            error={error} // TODO:check the required functionality
            inputComponent='setur'
          />
        ) : (
          <ResponsiveSingleDateSelect
            date={localStartDate}
            onDateChange={onDateChange}
            title='Gidiş Tarihiniz?'
            subTitle={`${formatMomentDate(localStartDate)}`}
            placeholder='Gidiş Tarihi'
            drawerTitle='Tarih Arama'
            arrowIcon={true}
            inputComponent='setur'
          />
        )
      ) : null}
      {tripType === 'round-trip' ? (
        xl ? (
          <SearchBarRangeDatePicker
            minimumNights={0}
            startDate={localStartDate}
            endDate={localEndDate}
            onDatesChange={onDatesChange}
            error={error}
            inputComponent='setur'
          />
        ) : (
          <ResponsiveDateRangeSelect
            startDate={localStartDate}
            endDate={localEndDate}
            onDatesChange={onDatesChange}
            title='Gidiş-Dönüş Tarihiniz?'
            subTitle={getDateRangePickerPlaceholder(
              localStartDate,
              localEndDate
            )}
            placeholder='Gidiş - Dönüş Tarihleri'
            drawerTitle='Tarih Arama'
            arrowIcon={true}
            inputComponent='setur'
          />
        )
      ) : null}
    </BookerSearchBarDateRangeInputWrapper>
  );
};
export default BookerFlightDatePicker;
